export function getUserTitleFromRoleName(roleName) {
  const roleMap = {
    'duallo-admin': 'Administrator',
    'organization-admin': 'Organization Admin',
    'asset-admin': 'Asset Administrator',
    'inspector': 'Inspector',
    'viewer': 'User'
  };

  return roleMap[roleName] || 'No Role Assigned';
}